//noinspection ThisExpressionReferencesGlobalObjectJS
/** @suppress {globalThis} */
(this["requireLib"] = require);
